import apiClient from '../../../../shared/services/apiClient';
import { unwrapEnvelopeData } from '../../../../shared/services/apiHelpers';
import MarketplaceService from './MarketplaceService';

const MarketplaceBuyerAuthService = {
  register(body) {
    return apiClient
      .post('/marketplace/auth/register', body, {
        withCredentials: true,
        skipAuthRefresh: true,
        headers: MarketplaceService.marketplaceHeaders(),
      })
      .then((r) => unwrapEnvelopeData(r));
  },

  getProfile() {
    return apiClient.get('/marketplace/me/profile').then((r) => unwrapEnvelopeData(r));
  },

  updateProfile(body) {
    return apiClient.put('/marketplace/me/profile', body).then((r) => unwrapEnvelopeData(r));
  },

  getFavourites() {
    return apiClient.get('/marketplace/me/favourites').then((r) => unwrapEnvelopeData(r));
  },

  mergeGuestFavourites(slugs) {
    return apiClient
      .post('/marketplace/me/favourites/merge', { slugs }, {
        headers: MarketplaceService.marketplaceHeaders(),
      })
      .then((r) => unwrapEnvelopeData(r));
  },

  resolveGuestFavourites(slugs) {
    return apiClient
      .post('/marketplace/favourites/resolve', { slugs }, {
        headers: MarketplaceService.marketplaceHeaders(),
      })
      .then((r) => unwrapEnvelopeData(r));
  },

  getEnquiries() {
    return apiClient.get('/marketplace/me/enquiries').then((r) => unwrapEnvelopeData(r));
  },
};

export default MarketplaceBuyerAuthService;
